import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import FilterModal from "../Contract/filterModal";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import axios from "axios";
import Spinner from "../Contract/Spinner";
import Cookies from "js-cookie";
import api from "../chat/api";
import CustomDropdown from "../Contract/CustomDropdown";
import useGooglePicker from "../Ocr_Data/useGooglePicker";
import { toast } from "../../utils/appToast";
import PdfViewer from "../chat/PdfViewer";
import FilterTags from "./FilterTags";
import TagOverflowTooltip from "../Tags/TagOverflowTooltip";
import CreateTagModals from "./CreateTagModals";
import GenerateProposalModal from "./GenerateProposalModal";
import FileNameWithTooltips from "../UploadFile/FileNameWithTooltips";
const ContractTable = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
const actionMenuRefs = useRef({});
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const fileInputRef = useRef(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
const[isCustomApplyFieldModal,setIsCustomApplyFiledModal] =useState(false);
const [selectedTab, setSelectedTab] = useState("manage");
const [fieldName, setFieldName] = useState("");
const [fieldPrompt, setFieldPrompt] = useState("");
const [customFields, setCustomFields] = useState([]);
const [loadingAddField, setLoadingAddField] = useState(false);
const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
const [deletingField, setDeletingField] = useState(null);
const isMaxFieldsReached = customFields.length >= 5;
const isFilled = fieldName.trim() && fieldPrompt.trim();
const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
const moreButtonRef = useRef(null);
const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
const [customFieldPopup, setCustomFieldPopup] = useState({
  visible: false,
  value: '',
  contractKey: '',
  contractId: '',
  x: 0,
  y: 0,
});
const safeColor = (hex) => (hex && hex.startsWith('#') ? hex : '#8B55DD');

const tooltipRef = useRef(null);
const [selectedFilterTags, setSelectedFilterTags] = useState([]); // array of tag IDs
const [filterTagObjects, setFilterTagObjects] = useState([]); // array of full tag objects
const filterButtonRef = useRef(null);
const [showTooltip, setShowTooltip] = useState(false);
const popupRef = useRef(null);
const uploadButtonRef = useRef(null);const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
const { isConnected, connect, disconnect, openPicker, accessToken } = useGooglePicker();
const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
const [isHovered, setIsHovered] = useState(false);
  const tbodyRef = useRef(null);
  const [selectedFilePreview, setSelectedFilePreview] = useState(null);
const [proposalPdfUrl, setProposalPdfUrl] = useState(null); // Store the PDF URL
const [isProposalPdfOpen, setIsProposalPdfOpen] = useState(false); // State to open the modal
const baseColumns = 7; // name, party A, party B, date, etc.
const totalColumns = baseColumns + customFields.length;
const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
const [isTagModalOpen, setIsTagModalOpen] = useState(false);
const [tagModalDocIds, setTagModalDocIds] = useState([]); // supports single or multi
const openTagModalFor = (docIdOrIds) => {
  const ids = Array.isArray(docIdOrIds) ? docIdOrIds : [docIdOrIds];
  setTagModalDocIds(ids);
  setIsTagModalOpen(true);
};
const [isProposalOpen, setIsProposalOpen] = useState(false);

const [isCreatingNew, setIsCreatingNew] = useState(false);
const [selectedField, setSelectedField] = useState('');
const [newFieldName, setNewFieldName] = useState('');
const [newPrompt, setNewPrompt] = useState('');
const [isLoading, setIsLoading] = useState(false);



const contractKeys = selectedContracts; // update as needed



const handleGenerateFromRfp = async (payload) => {
  // payload = { type: 'upload', file } OR { type: 'existing', id, key, name }
  if (payload.type === "upload") {
    // keep your existing upload flow:
    setFile([payload.file]);
    setIsModalOpen(true);
    setIsProposalOpen(false);
    return;
  }

  if (payload.type === "existing") {
    const pdfKey = payload.key;
    try {
      await api.post(`/api/v1/rfp/documents/${pdfKey}/extract-questions/`);
      setIsProposalOpen(false);
      navigate(`/create-proposal-question/${pdfKey}`);
    } catch (err) {
      console.error("Extract questions failed", err);
    }
  }
};


  function darkenColor(hex, amount = 0.4) {
  if (!hex || !hex.startsWith('#')) return '#333';
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  // darken each channel
  r = Math.floor(r * (1 - amount));
  g = Math.floor(g * (1 - amount));
  b = Math.floor(b * (1 - amount));

  return `rgb(${r}, ${g}, ${b})`;
}
const handleFilterClear = () => {
  setSelectedFilterTags([]);
  setFilterTagObjects([]);
  setIsFilterModalOpen(false);
  setFilterApplied(false); // 👈 ensure default unfiltered state
  fetchContracts(); // ⬅ reload entire table without any filters
};

const handleDownload = async (contractId) => {
  try {
    // Call the API to get the proposal file directly
    const response = await api.get(`/api/v1/rfp/proposals/${contractId}/download/`, {
      responseType: 'blob', // Set response type to 'blob' to handle binary data
    });

    // Log the response to inspect it
    console.log("Download Response:", response); // Check the response structure

    if (response.status === 200 && response.data) {
      // Log the raw binary data to inspect
      console.log("File Blob Data:", response.data);

      // Create a Blob from the response data (this will be the binary file)
      const file = new Blob([response.data], { type: 'application/docx' }); // Adjust MIME type if necessary

      // Create a temporary link element to trigger the download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(file); // Create a URL for the Blob
      link.download = `proposal_${contractId}.docx`; // Provide a name for the file

      // Append the link to the document, trigger the click, and then remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the object URL after download
      URL.revokeObjectURL(link.href);
    } else {
      toast.error("Download failed. No data found.");
    }
  } catch (error) {
    console.error("Error downloading proposal:", error);
    toast.error("Failed to download proposal.");
  }
};



useEffect(() => {
  if (isConnected && !hasOpenedPickerOnce) {
    // Don't open picker here
    setHasOpenedPickerOnce(true);
  }
}, [isConnected, hasOpenedPickerOnce]);
const handleAddFromDriveClick = () => {
  openPicker(async (docs) => {
    console.log("📄 Files picked:", docs);

    try {
      const files = await Promise.all(
        docs.map(async (doc) => {
          const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (!res.ok) throw new Error("Failed to fetch file from Drive");

          const blob = await res.blob();
          return new File([blob], doc.name, { type: blob.type });
        })
      );

      setFile(files); // 👈 trigger your upload flow
      setIsModalOpen(true); // 👈 open modal
    } catch (err) {
      console.error("Failed to process selected files", err);
      toast.error("Something went wrong while processing selected files.");
    }
  });
};





const handleToggleMore = () => {
  if (isActionMenuOpen === "more") {
    setIsActionMenuOpen(null);
  } else {
    const rect = moreButtonRef.current.getBoundingClientRect();
    setDropdownCoords({
      top: rect.bottom + window.scrollY + 6,  // Add spacing
      left: rect.left + window.scrollX,       // Align horizontally
    });
    setIsActionMenuOpen("more");
  }
};

const isAllChecked =
  selectedContracts.length === contracts.length && contracts.length > 0;

  const navigate = useNavigate();






  useEffect(() => {
      const cookieToken = Cookies.get("access_token");
      if (cookieToken) {
        setToken(cookieToken);
      } else {
        console.error("Access token missing from cookies");
      }
    }, []);

  const toggleModal = () => {
    
    setIsModalOpen((prev) => !prev);
  };
const handleDeleteField = async (fieldId) => {
  try {
    await api.delete(`/api/v1/contract/delete-field/${fieldId}/`);
  } catch (error) {
    console.error("Error deleting field", error);
  } finally {
    setDeletingField(null);
  }
};











  const handleCancel = () => {
    setSelectedContracts([]);

    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);

    setConfirmDeleteVisible(false);
  };
const handleFilterApply = (selectedNames) => {
  setSelectedFilterTags(selectedNames); // still names like ['kunalll', 'helloss']
  setIsFilterModalOpen(false);

  const orgId = Cookies.get("selected_org_id");
  const params = { tags: selectedNames.join(",") };
  if (orgId) params.organization_id = orgId;

  api.get("/api/v1/rfp/knowledge-base/documents/", { params })
  .then(res => {
    // Check if results are an array and if it's not empty
    const results = Array.isArray(res.data.results) ? res.data.results : [];
    const filteredContracts = results.length > 0 ? results : [];  // Ensure it's always an array

    // Set filterTagObjects (empty array in case of no results)
    setFilterTagObjects(filteredContracts);

    // Update contracts as well
    setContracts(filteredContracts);  // This will update the table
  })
  .catch((err) => {
    console.log(err, "Failed to apply tag filters.");
    // Optionally handle error, like showing a toast or setting default states
  });
};

  const fetchContracts = useCallback(async () => {
    if (!token) return;
    setLoading(true);

    try {
      const response = await api.get("/api/v1/rfp/proposals/");

    const data = response.data;
    const proposals = Array.isArray(data) ? data : data.results || [];

    setContracts(proposals);
console.log("Fetched contracts:", data);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const tableBodyRef = useRef(null);

  const scrollToTop = () => {
    if (tableBodyRef.current) {
      tableBodyRef.current.scrollTop = 0;
    }
  };

  const handleSelectAll = () => {
    if (selectedContracts.length === contracts.length) {
      setSelectedContracts([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedContracts(contracts.map((contract) => contract.id));
      setSelectedContractKeys(contracts.map((contract) => contract.key));
    }
  };

const filteredContracts = useMemo(() => {
  const query = searchQuery.toLowerCase().trim();

  if (!query) return contracts;

  return contracts.filter((contract) => {
    const contractName = contract.name?.toLowerCase() || "";
    const proposalName = contract.rfp_document_name?.toLowerCase() || ""; // ✅ proposal name
    const ownerName = contract.details?.["Client name"]?.toLowerCase() || "";
    const customerName = contract.details?.["Company Name"]?.toLowerCase() || "";

    return (
      contractName.includes(query) ||
      proposalName.includes(query) || // ✅ added
      ownerName.includes(query) ||
      customerName.includes(query)
    );
  });
}, [contracts, searchQuery]);


  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;
const currentContracts = useMemo(() => {
  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;

  // Ensure filteredContracts is always an array before calling .slice()
  const contractsArray = Array.isArray(filteredContracts) ? filteredContracts : [];
  return contractsArray.slice(indexOfFirstContract, indexOfLastContract);
}, [filteredContracts, currentPage, rowsPerPage]);


  const totalPages = useMemo(
    () => Math.ceil(filteredContracts.length / rowsPerPage),
    [filteredContracts, rowsPerPage]
  );
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

const handleRowsPerPageChange = (event) => {
  setRowsPerPage(25); 
};



const handleProposalClick = async (proposalId) => {
  try {
    const response = await api.get(`/api/v1/rfp/proposals/${proposalId}/`);
    
    if (response && response.data) {
      const pdfUrl = response.data.file_url; 
      
      setProposalPdfUrl(pdfUrl);
      setIsProposalPdfOpen(true); 
    }
  } catch (error) {
    console.error("Error fetching proposal:", error);
    toast.error("Failed to fetch proposal.");
  }
};



  const handleCheckboxChange = (id, key) => {
    if (selectedContracts.includes(id)) {
      setSelectedContracts(
        selectedContracts.filter((contractId) => contractId !== id)
      );
      setSelectedContractKeys(
        selectedContractKeys.filter((contractKey) => contractKey !== key)
      );
    } else {
      setSelectedContracts([...selectedContracts, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  useEffect(() => {
    if (token) {
      fetchContracts();
    }
  }, [fetchContracts, token]);

  const handleUploadSuccess = () => {
    fetchContracts();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchContracts();
  };

  const handlePageChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0, openUpwards: false });

const toggleActionMenu = (index, event) => {
  const menuHeight = 150; // Approximate height of the action menu
  const rect = event.currentTarget.getBoundingClientRect();
  const bottomSpace = window.innerHeight - rect.bottom;

  const openUpwards = bottomSpace < menuHeight;

  setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
  setActionMenuPosition({
    top: openUpwards ? rect.top - menuHeight : rect.bottom,
    left: rect.left,
    openUpwards,
  });
};

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

  const handleViewMore = (contractKey,id) => {
    const condition = "table";
    navigate(`/Contract/contract-details/${contractKey}`, {
  state: { id }, // still send `id` in state if needed
});

  };

  const enableEdit = (contract) => {
    if (contract) {
      setIsActionMenuOpen(false);
      setEditContractId(contract.id);
      setEditedContractData({
        ...contract, // Ensure all contract fields are copied
        details: {
          ...contract.details,
              _custom_fields: contract.details?._custom_fields || {},
 // Ensure existing contract details are copied
        },
      });
    } else {
      setEditContractId(null);
      setEditedContractData({});
    }
  };

const handleEditChange = (field, value) => {
  setEditedContractData((prev) => {
    if (field.startsWith("details._custom_fields.")) {
      const key = field.split(".")[2];
      return {
        ...prev,
        details: {
          ...prev.details,
          _custom_fields: {
            ...prev.details?._custom_fields,
            [key]: value,
          },
        },
      };
    } else if (field.startsWith("details.")) {
      const key = field.split(".")[1];
      return {
        ...prev,
        details: {
          ...prev.details,
          [key]: value,
        },
      };
    } else {
      return {
        ...prev,
        [field]: value,
      };
    }
  });
};


const handleClickOutside = (event) => {
  if (
    isActionMenuOpen !== null &&
    actionMenuRefs.current[isActionMenuOpen] &&
    !actionMenuRefs.current[isActionMenuOpen].contains(event.target)
  ) {
    setIsActionMenuOpen(null);
  }

  if (
    confirmDeleteVisible &&
    event.target.closest(".popup-overlay") === null &&
    !event.target.closest(".popup-box-delete")
  ) {
    setConfirmDeleteVisible(false);
  }
};




  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [confirmDeleteVisible, isActionMenuOpen]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };
  const handleDelete = (contractId) => {
    
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
   

    if (!selectedContracts || selectedContracts.length === 0) {
      showPopup("Error", "Please select at least one contract to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const handleEditSave = async (contractId) => {
    
  
    try {
      const payload = {
        edited_data: {
    "Client name": editedContractData.details?.["Client name"],
    "Company Name": editedContractData.details?.["Company Name"],
    "Effective Date": editedContractData.details?.["Effective Date"],
    "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ ADD THIS
    "Expiration Date": editedContractData.details?.["Expiration Date"],
    _custom_fields: editedContractData.details?._custom_fields || {},
  },
        note: editedContractData.note || "",
        name: editedContractData.name || "",
        contract_key: editedContractData.key,  // make sure this is present
      };
  
      const response = await api.post(
        `api/v1/contract/edit-contract-details/${editedContractData.key}/`,
        {
          edited_data: {
            "Client name": editedContractData.details?.["Client name"],
            "Company Name": editedContractData.details?.["Company Name"],
            "Effective Date": editedContractData.details?.["Effective Date"],
                  "Renewal Date": editedContractData.details?.["Renewal Date"], // ✅ FIXED

            "Expiration Date": editedContractData.details?.["Expiration Date"],
            _custom_fields: editedContractData.details?._custom_fields || {}, 
          },
          note: editedContractData.note || "",
          contract_name: editedContractData.name || "",
        }
      );
      
      
  
      if (response.status === 200) {
        const updatedContract = response.data;
        setContracts((prevContracts) =>
          prevContracts.map((contract) =>
            contract.id === contractId ? updatedContract : contract
          )
        );
        setEditContractId(null);
       setRenameSuccessRowId(contractId); // Show success message only for that row

setTimeout(() => setRenameSuccessRowId(null), 4000);
        fetchContracts(); // refresh full list if needed
      }
    } catch (error) {
      console.error("Error saving contract:", error);
      showPopup("Error", "Failed to update contract. Please try again.");
    }
  };
  

const confirmDelete = async () => {
  const idsToDelete = isBulkDelete ? selectedContracts : [contractToDelete];

  if (!idsToDelete?.length) return;

  setDeleteInProgress(true);

  try {
    // Prepare the API request payload
    const payload = {
      proposal_ids: idsToDelete,
    };

    // Make a single delete request with multiple doc_ids
    const res = await api.delete("/api/v1/rfp/proposals/delete/", { data: payload });

    // Assuming the API returns a status or list of successfully deleted docs
    const deletedDocs = res?.data?.deletedDocs || [];
    const failedDocs = res?.data?.failedDocs || [];

    // Remove deleted documents from the table
    if (deletedDocs.length > 0) {
      setContracts((prev) => prev.filter((c) => !deletedDocs.includes(c.id)));
    }

    // Show failures if any
    if (failedDocs.length > 0) {
      const msg = failedDocs
        .map((f) => `Document ID ${f.id}: ${f.error}`)
        .join("\n");
      showPopup("Deletion Failed", msg);
    }

    // Clear selections after operation
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  } catch (error) {
    console.error("Error deleting documents:", error);
    showPopup("Error", "Failed to delete document(s). Please try again.");
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  } finally {
    setDeleteInProgress(false);
    setConfirmDeleteVisible(false);
    setContractToDelete(null);
    // Optional: refresh to be 100% in sync with backend
    fetchContracts();
  }
};



  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editContractId]);

const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const toInputDateValue = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  // Prevent timezone offset issue by manually extracting parts
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // yyyy-MM-dd
};




  const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
  const selectedFiles = Array.from(event.target.files || []);
  if (selectedFiles.length === 0) return;

  setFile(selectedFiles); // ✅ save to state
  setIsModalOpen(true);
};

  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      {loading && <Spinner />}
      <div className="full-container max-w-full overflow-x-hidden" 
>

        <div className="">
<Header name="Response Writer" icon={""} isMenuOpen={isMenuOpen} />
        </div>

        <div className="contract-table-container relative overflow-x-hidden">
     <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[6px]">
  {/* LEFT: Search & Filter */}
  <div className="flex items-center gap-1 min-w-[300px]" style={{ marginLeft: isMenuOpen ? "206px" : "110px" }}>
    {/* Search */}
    <div
      style={{
        display: 'flex',
        width: '310px',
        height: '40px',
        padding: '8px 20px 8px 26px',
        alignItems: 'center',
        gap: '1px',
        flexShrink: 0,
        borderRadius: '20px',
        border: isSearchFocused
          ? '1px solid rgba(187, 66, 174, 0.36)'
          : '1px solid rgba(0, 0, 0, 0.10)',
        backgroundColor: '#FFF',
        boxShadow: isSearchFocused
          ? '0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)'
          : 'none',
        overflow: 'hidden',
      }}
    >
      <img
        src="/search.svg"
        alt="Search"
        style={{ width: '24px', height: '24px', marginRight: '4px' }}
      />
      <input
        type="text"
        placeholder="Search Documents Here"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsSearchFocused(true)}
        onBlur={() => setIsSearchFocused(false)}
        style={{
          fontFamily: 'Outfit, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          border: 'none',
          outline: 'none',
          width: '100%',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          color: '#171717',
        }}
      />
    </div>

<div className="relative inline-flex items-center gap-2 flex-wrap mt-1">
  {/* Filter Button */}
  {/* <button
    ref={filterButtonRef}
    className={`${selectedFilterTags.length ? "filter-applieds" : ""}`}
    onClick={toggleFilterModal}
  >
    <img
      src={selectedFilterTags.length ? "/Filter_CTA.png" : "/filter.svg"}
      alt="Filter Icon"
    />
  </button> */}

  {/* 🔽 Background Blur Overlay */}
  {isFilterModalOpen && (
    <div className="fixed inset-0 z-[998] bg-black/5 backdrop-blur-[1.5px]" />
  )}

  {/* 🔽 Filter Dropdown */}
  {isFilterModalOpen && (
    <FilterTags
      selectedTags={filterTagObjects}
      onApply={handleFilterApply}
      onClear={handleFilterClear}
      onClose={() => setIsFilterModalOpen(false)}
      anchorRef={filterButtonRef}
    />
  )}

  {/* Selected tags */}
  {/* {filterTagObjects.slice(0, 2).map((tag) => (
    <div
      key={tag.id}
      className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] whitespace-nowrap"
      style={{
        backgroundColor: `${tag.color}1A`,
        border: `2px solid ${tag.color}`,
        color: darkenColor(tag.color),
      }}
    >
      {tag.name}
    </div>
  ))} */}

  {/* "+N" More tags with tooltip */}
  {filterTagObjects.length > 2 && (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      ref={tooltipRef}
    >
      <div
        className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] cursor-default"
        style={{
          backgroundColor: "#F4EBFF",
          border: "1px solid #8B55DD",
          color: "#8B55DD",
        }}
      >
        +{filterTagObjects.length - 2}
      </div>

      {showTooltip && (
        <TagOverflowTooltip
          tags={filterTagObjects.slice(2)}
          anchorRef={tooltipRef}
        />
      )}
    </div>
  )}
</div>
  </div>

  {/* RIGHT SIDE ACTIONS */}
  <div className="flex items-center gap-3 flex-wrap justify-end">
    {selectedContracts.length > 0 ? (
      <>
   


       

    
          <button
       onClick={handleBulkDelete}
   
      className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-transparent bg-red-100 hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
    >
      <img src="/delete-icon-red.svg" alt="Delete" className="w-4 h-4" />
      <span className="text-[rgba(226,25,25,0.76)] font-[Outfit] text-[14px] font-medium leading-none">
        Delete
      </span>
    </button>

    {/* ✅ Cancel Button */}
    <button
      onClick={handleCancel}
      className="flex items-center justify-center gap-1 p-2 rounded-full border border-[rgba(0,0,0,0.10)] bg-[#ECECEC] transition"
    >
      <img
        src="/cancel_icon.svg"
        alt="Cancel Icon"
        className="w-5 h-5 min-w-[20px] min-h-[20px]"
      />
    </button>
      </>
    ) : (
      <>
        {/* <button
          className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
          onClick={() => setIsCustomFieldModalOpen(true)}
        >
          <img src="/custom-field-icons.svg" className="w-5 h-5" />
          <span className="new-custom-butons-design-text">Custom Field</span>
        </button> */}

        {/* Upload Button + Tooltip */}
        <div className="relative">
       <button
  ref={uploadButtonRef}
  className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
  onClick={() => setIsProposalOpen(true)}
>
  <img src="/upload_icon_white.svg" className="w-5 h-5" />
  <span className="new-custom-butons-design-texts">Create Proposal</span>
</button>

      
      
                {/* Tooltip */}
              {isTooltipVisible && (
                <div
                  className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
                  style={{
                    top: `${tooltipCoords.top + 10}px`,
                    left: `${tooltipCoords.left - 50}px`,
                  }}
                  onMouseLeave={() => setIsTooltipVisible(false)}
                >
                  {/* Upload from Device */}
                  <div
                    className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
                    onClick={() => {
                      setIsTooltipVisible(false);
                      fileInputRef.current.click();
                    }}
                  >
                    <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
                    Add from device
                  </div>
              
                  {/* Connect Google Drive */}
                  {!isConnected && (
                    <div
                      className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
                      onClick={() => {
                        setIsTooltipVisible(false);
                        navigate("/account/integration");
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                    >
               <img
                    src={isHovered ? "/connect-icon-hover.svg" : "/connect-icon.svg"}
                    alt="Open Picker"
                    className="w-4 h-4 transition-all duration-150"
                  />        Connect Drive
                    </div>
                  )}
              
                  {/* File Picker if connected */}
            {isConnected && (
  <div
    className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    onClick={handleAddFromDriveClick} // Trigger the picker on click
  >
    <img
      src={isHovered ? "/picker-icon-hover.svg" : "/picker-icon.svg"}
      alt="Open Picker"
      className="w-4 h-4 transition-all duration-150"
    />
    Add from Drive
  </div>
)}
                </div>
              )}

          <input
            ref={fileInputRef}
            type="file"
            multiple
            className="hidden"
            accept=".pdf,.jpeg,.jpg,.png,.csv,.xlsx,.xls,.docx,.doc"
            onChange={handleFileChange}
          />
        </div>
      </>
    )}
  </div>
</div>


       <div
        className={`overflow-x-auto  transition-all duration-300 mt-2 w-full`}
        style={{
          marginLeft: isMenuOpen ? "182px" : "80px"
        }}
      >
    <div className="overflow-x-auto w-[100%]">
      
      <div className="relative overflow-x-auto  custom-scrollbar-container"  style={{
      height: "calc(100vh - 158px)", // Adjust height as needed
    }}
    ref={tbodyRef}>
<table
  className="text-sm text-left table-auto w-full"
 
>



              <thead className="bg-[#FFF] h-[40px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
                <tr>
                  <th className="w-[40px] px-3">
                   <input
  type="checkbox"
  className="custom-checkbox"
  style={{
    appearance: "none",
    // width: "16px",
    // height: "16px",
    border: "1.5px solid #c0c0c0",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundImage: isAllChecked ? "url('/checck.svg')" : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  }}
  onChange={handleSelectAll}
  checked={isAllChecked}
/>

                  </th>
                  {/* <th>Contract ID</th> */}
                  <th className="w-[150px] file-size-of-heading">Proposals</th>

                  <th className="w-[180px] px-3 file-size-of-heading">Size</th>
                  <th className="w-[100px] px-3 file-size-of-heading">Created on</th>  
                                    <th className="w-[140px]  file-size-of-heading">Generated Requirements</th>                
              
                  <th className="w-[230px] px-3 file-size-of-heading">Actions</th>
                </tr>
              </thead>
                <tbody
                  className={
                    currentContracts.length > rowsPerPage ? "scrollable" : ""
                    
                  }
                  style={{
                    overflowY:
                      currentContracts.length > rowsPerPage ? "auto" : "hidden",
                    maxHeight: "400px",
    backgroundColor: "#FFF",
                    
                  }}
                >
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : contracts.length > 0 ? (
                  currentContracts.map((contract, index) => (
                    <tr
                      key={index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      style={{
                        background:
                          hoveredRow === index ? "#F8F3FF" : "transparent",
                        boxShadow:
                          hoveredRow === index
                            ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
                            : "none",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                                            className="h-[36px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"

                    >
                      <td className="px-3">
                       <input
  type="checkbox"
  className="custom-checkbox"
  style={{
    appearance: "none",
    // width: "16px",
    // height: "16px",
    border: "1.5px solid #c0c0c0",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundImage: selectedContracts.includes(contract.id)
      ? "url('/checck.svg')"
      : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  }}
  checked={selectedContracts.includes(contract.id)}
  onChange={() =>
    handleCheckboxChange(contract.id, contract.key)
  }
/>

                      </td>

                      {editContractId === contract.id ? (
                        <>
                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={editedContractData.name || ""}
                              onChange={(e) => handleEditChange("name", e.target.value)}
                              className="edit-contract-custom-two"
                              style={{ color: "#B793ED" }}
                            />
                          </td>
                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={
                                editedContractData.details?.["Client name"] ||
                                ""
                              }
                              onChange={(e) =>
                                handleEditChange(
                                  "details.Client name",
                                  e.target.value
                                )
                              }
                              className="edit-contract-custom-one"
                            />
                          </td>

                          <td className="file-size-of-subheading">
                            <input
                              type="text"
                              value={
                                editedContractData.details?.["Company Name"] ??
                                contract.details?.["Company Name"] ??
                                ""
                              }
                              onChange={(e) =>
                                handleEditChange(
                                  "details.Company Name",
                                  e.target.value
                                )
                              }
                              className="edit-contract-custom-one"
                            />
                          </td>
                          <td className="file-size-of-subheading">
                           <input
  type="date"
  value={
    editedContractData.details?.["Effective Date"]
      ? toInputDateValue(editedContractData.details?.["Effective Date"])
      : ""
  }
  onChange={(e) =>
    handleEditChange("details.Effective Date", e.target.value)
  }
  className="edit-contract"
/>

                          </td>

                          {customFields.map((fieldObj, index) => {
  const fieldKey = fieldObj.field;
  return (
    <td key={index} className="file-size-of-subheading">
      <input
        type="text"
        value={
          editedContractData.details?._custom_fields?.[fieldKey] || ""
        }
        onChange={(e) =>
          handleEditChange(
            `details._custom_fields.${fieldKey}`,
            e.target.value
          )
        }
        className="edit-contract"
      />
    </td>
  );
})}

                          
                          <td className="file-size-of-subheading">
  <input
    type="date"
    value={
      editedContractData.details?.["Renewal Date"]
        ? toInputDateValue(editedContractData.details?.["Renewal Date"])
        : ""
    }
    onChange={(e) =>
      handleEditChange("details.Renewal Date", e.target.value)
    }
    className="edit-contract"
  />
</td>



                          <td className="file-size-of-subheading">
                           <input
  type="date"
  value={
    editedContractData.details?.["Expiration Date"]
      ? toInputDateValue(editedContractData.details?.["Expiration Date"])
      : ""
  }
  onChange={(e) =>
    handleEditChange("details.Expiration Date", e.target.value)
  }
  className="edit-contract"
/>

                          </td>
                          <td className="action-icons-contract">
                            <button
                              onClick={() => handleEditSave(contract.id)}
                              className="icon-button-contract"
                            >
                              <img
                                src="/save-icon-contracttable.svg"
                                alt="Save"
                                className="action-icon"
                              />
                            </button>
                            <button
                              onClick={() => setEditContractId(null)}
                              className="icon-button-contract"
                            >
                              <img
                                src="/cancel-icon-contracttable.svg"
                                alt="Cancel"
                                className="action-icon"
                              />
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
          
<td className="px-1 truncate" style={{ cursor: 'pointer', color: '#B793ED', textDecoration: 'underline' }}>
  <div className="flex items-center gap-2 cursor-pointer text-[#B793ED] underline" onClick={() => handleProposalClick(contract.id)}>
                                  <img
                                    src={
                                      contract.documents
                                        ? "/folder-icon-new.svg"
                                        : contract.file_type === "pdf"
                                        ? "/pdff.svg"
                                        : contract.file_type === "xlsx"
                                        ? "/Xls.svg"
                                        : contract.file_type === "docx"
                                        ? "/docX.svg"
                                        : contract.file_type === "csv"
                                        ? "/CSV.svg"
                                        : contract.file_type === "txt"
                                        ? "/TXT.svg"
                                        : contract.file_type === "xls"
                                        ? "/Xls.svg"
                                        : "/pdf.svg"
                                    }
                                    className="w-5 h-5"
                                    alt="Icon"
                                  />
                        <FileNameWithTooltips name={contract.rfp_document_name} />
        
                                </div>
                        
                              </td>
 

     
                          <td className="px-3 file-size-of-subheading">
          {contract.size_mb || "N/A"}
        </td>

        {/* Upload Date */}
        <td className="px-3 file-size-of-subheading">
          {formatDate(contract.created_at)}
        </td>



<td>
  <button
    onClick={(e) => {
      e.stopPropagation();
     navigate(`/create-proposal-question/${contract.document_key}`);
    }}
    className="
      group flex items-center justify-center gap-[6px] 
      px-4 py-[6px] 
      rounded-md border border-[rgba(0,0,0,0.10)] 
      text-[#3F3F46] font-medium text-[14px] font-['Outfit']
      transition-colors duration-200
      hover:border-[#8B55DD] hover:bg-[#8B55DD] hover:text-[#F5F4F3]
    "
  >
    {/* Default icon */}
    <img
      src="/chat-icon-docs.svg"
      className="w-4 h-4 block group-hover:hidden"
      alt="Chat"
    />
    {/* Hover icon */}
    <img
      src="/chat-icon-doc-hover.svg"
      className="w-4 h-4 hidden group-hover:block"
      alt="Chat"
    />
    Click Here
  </button>
</td>



<td className="px-3 file-size-of-subheading">
  <img
    src="./action.svg"
    alt="Actions"
    width="20"
    height="20"
    onClick={(e) => toggleActionMenu(index, e)}
    style={{ cursor: "pointer" }}
  />
  {isActionMenuOpen === index && !selectedFilePreview && (  
    <div
      className="action-menu"
      style={{
        position: 'fixed',
        top: actionMenuPosition.openUpwards ? `${actionMenuPosition.top}px` : `${actionMenuPosition.top}px`,
        left: `${actionMenuPosition.left - 215}px`,
        transform: actionMenuPosition.openUpwards ? 'translateY(50%)' : 'none',
        zIndex: 9999,
      }}
      ref={(el) => {
        if (el) actionMenuRefs.current[index] = el;
      }}
    >
      {/* Eye Icon for Preview */}
    
      {/* Delete Option */}
      <div
        className="action-item"
        onMouseEnter={() => setHoveredAction("delete")}
        onMouseLeave={() => setHoveredAction(null)}
        onMouseDown={() => setClickedAction("delete")}
        onMouseUp={() => setClickedAction(null)}
        onClick={() => handleDelete(contract.id)}
        style={{
          color:
            clickedAction === "delete"
              ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
              : hoveredAction === "delete"
              ? "var(--reeedd, rgba(226, 25, 25, 0.75))"
              : "",
          transition: "color 0.2s ease-in-out",
          borderRadius: "8px",
          background:
            clickedAction === "delete" || hoveredAction === "delete"
              ? "#FAF9F6"
              : "transparent",
        }}
      >
        <img
          src={clickedAction === "delete" ? "./delete-active-contract.svg" : hoveredAction === "delete" ? "./delete-active-contract.svg" : "./delete.svg"}
          alt="Delete Icon"
          className="action-icon"
        />
        <p>Delete</p>
      </div>

       <div
      className="action-item"
      onMouseEnter={() => setHoveredAction("download")}
      onMouseLeave={() => setHoveredAction(null)}
      onMouseDown={() => setClickedAction("download")}
      onMouseUp={() => setClickedAction(null)}
      onClick={() => handleDownload(contract.id)} // Trigger download on click
      style={{
        color:
          clickedAction === "download"
            ? "var(--blue, rgba(28, 28, 107, 0.75))"
            : hoveredAction === "download"
            ? "var(--blue, rgba(28, 28, 107, 0.75))"
            : "",
        transition: "color 0.2s ease-in-out",
        borderRadius: "8px",
        background:
          clickedAction === "download" || hoveredAction === "download"
            ? "#F0F8FF"
            : "transparent",
      }}
    >
      {/* <img
        src={clickedAction === "download" ? "./export-icon-blue.svg" : hoveredAction === "download" ? "./export-icon-blue.svg" : "./export-icon-blue.svg"}
        alt="Download Icon"
        className="action-icon"
      /> */}
      <span className="h-6 w-6">📥</span>
      <p className="ml-1">Download</p>
    </div>
    </div>
  )}
</td>






                        </>
                      )}
                    </tr>
                  ))
                
                    ) : (
                  <tr className="h-[44px] text-center">
                    <td colSpan="7" className="py-6 text-black-400">
                      <img
                        src="/no-contracts.svg"
                        alt="No Data"
                        className="mx-auto mb-2"
                      />
                      <p className="text-[16px]">Looks like your table is empty!</p>
                    </td>
                  </tr>
                )}
             
              </tbody>
            </table>
          </div>
            {contracts.length > 0 && (
              <div className="pagination-doc ml-2">
                  <div className="pagination-dropdown">
  <p className="page-selector">{currentPage}</p>
</div>
                <p className="contentDown">of {totalPages} pages</p>
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="decrease.svg"
                    alt="Previous Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="increase.svg"
                    alt="Next Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
              </div>
            )}
             </div>
          </div>
        </div>

        {popupVisible && (
                    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box">
              <h2>{popupTitle}</h2>
              <p>{popupMessage}</p>
              <button onClick={closePopup} className="popup-close-button">
                Close
              </button>
            </div>
          </div>
        )}

                       {confirmDeleteVisible && (
  <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
    <div className="popup-box-delete">
      <h2>Are you sure you want to delete the selected spreadsheet?</h2>
      <p>
        {isBulkDelete
          ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
          :  "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
      </p>
      <div
        style={{
          display: "flex",
          gap: "8px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
       
        <button
          onClick={() => setConfirmDeleteVisible(false)}
          disabled={deleteInProgress}
          className="document-popup-close-delete"
        >
          Cancel
        </button>
         <button
          onClick={confirmDelete}
          disabled={deleteInProgress}
          className="document-popup-close-button"
        >
          {deleteInProgress ? "Deleting..." : "Delete"}
        </button>
      </div>
    </div>
  </div>
)}
        <UploadModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onUploadSuccess={handleUploadSuccess}
          type={"rfp_knowledge"}
          file={file}
        />

      
        {isCustomFieldModalOpen && (
  <div className="custom-modal-overlay-inline show">
    <div className="custom-modal-content-custom active relative">
      <button
        className="close-modal-custom"
        onClick={() => setIsCustomFieldModalOpen(false)}
      >
        ×
      </button>

      <h2 className="custom-modal-title-custom">Custom Fields</h2>
      <p className="custom-modal-subtitle-custom">
        You can only create up to 5 custom fields per document.<br />
        Deleting a field won’t reset the limit.
      </p>

      <div className="custom-modal-tabs-custom">
        <button
          className={`manage-btn-custom ${selectedTab === "manage" ? "active" : ""}`}
          onClick={() => setSelectedTab("manage")}
        >
          {customFieldsLoading ? "Loading..." : `Manage Existing Fields (${customFields.length}/5)`}
        </button>
        <button
          className={`create-btn-custom ${selectedTab === "create" ? "active" : ""}`}
          onClick={() => setSelectedTab("create")}
        >
          Create New Field
        </button>
      </div>

      {selectedTab === "create" && (
        <>
          <label className="field-label-custom">
            Field name <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <input
            type="text"
            className="input-field-custom"
            value={fieldName}
            onChange={(e) => setFieldName(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Maximum 5 fields allowed. Please delete one to add new."
                : "Enter your field name here"
            }
            disabled={isMaxFieldsReached}
          />
          <label className="field-label-custom">
            Extraction Prompt <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <textarea
            className="textarea-field-custom"
            value={fieldPrompt}
            onChange={(e) => setFieldPrompt(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Cannot enter prompt. Maximum limit reached."
                : "Enter your Extraction Prompts here"
            }
            disabled={isMaxFieldsReached}
          />
          <button
            className={`add-field-btn-custom ${isFilled && !loadingAddField && !isMaxFieldsReached ? "active" : ""}`}
            // onClick={handleAddField}
            disabled={loadingAddField || isMaxFieldsReached}
          >
            {loadingAddField ? "Adding..." : "Add Field"}
          </button>
        </>
      )}

      {selectedTab === "manage" && (
        <div>
          <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
            <div className="flex mt-2 gap-[60px]">
              <h2 className="field-name-custom">Field Name</h2>
              <h2 className="field-name-custom">Prompt</h2>
            </div>
            {customFields.length ? (
              customFields.map((field, index) => (
                <div key={index}>
                  <div className="flex items-start gap-[26px] mt-[12px]">
                  <p className="text-[#1A1A1A] text-sm font-medium w-[100px] break-words">
  {field.field}
</p>

                    <p className="text-[#1A1A1A] text-sm w-[139px]">
                      {field.description}
                    </p>
                    <button
  className="button-red-custom-field"
  onClick={() => {
    setDeletingField(field.id);
    handleDeleteField(field.id);
  }}
  disabled={deletingField === field.id}
>
  {deletingField === field.id ? "Deleting" : "Delete"}
  <img src="/delete-icon-red.svg" alt="Delete" />
</button>

                  </div>
                  <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500 ml-2 mt-3">No custom fields available.</p>
            )}
          </div>

          <button
            className="add-field-btn-custom-twos absolute bottom-4 right-4"
            onClick={async () => {
              await fetchContracts(); // refresh table to show new field
              setIsCustomFieldModalOpen(false);
            }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  </div>
)}
{fieldCreationSuccess && (
  <div className="success-popup inline-flex items-center p-4 bg-white border border-gray-200 shadow-sm rounded-md text-sm text-gray-700 fixed z-[100]"
       style={{
         top: "50%",
         left: "50%",
         transform: "translate(-50%, -50%)"
       }}>
    <img src="/green-icon-tick.svg" className="mr-2" alt="Success" />
    Field Created successfully, Select documents to apply this field
  </div>
)}

{isCustomApplyFieldModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
    <div
      className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
      style={{
        boxShadow:
          '130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)',
      }}
    >
      <div className="flex justify-between items-center">
        <h2 className="apply-heading-cutom">
          Apply Custom Field
        </h2>
         <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
          {selectedContracts.length} Contracts selected
        </span>
        <span
         onClick={() => setIsCustomApplyFiledModal(false)}
          className="cursor-pointer text-xl"
        >
          ×
        </span>
      </div>

     

      <div className="flex gap-8 mt-[20px] items-start">
  {/* Option 1: Select Existing */}
  <label className="flex items-center gap-2 cursor-pointer">
    <input
      type="radio"
      checked={!isCreatingNew}
      onChange={() => setIsCreatingNew(false)}
      className="accent-[#7F56D9] w-4 h-4"
    />
    <span className="apply-dot-heading">
      Select from Existing Field
    </span>
  </label>

  {/* Option 2: Create New Field + (2/5 used) below it */}
  <label className="flex flex-col cursor-pointer">
    <div className="flex items-center gap-2">
      <input
        type="radio"
        checked={isCreatingNew}
        onChange={() => setIsCreatingNew(true)}
        className="accent-[#7F56D9] w-4 h-4"
      />
      <span className="apply-dot-heading">
        Create New Field
      </span>
    </div>
<span className="text-xs text-[#999] ml-6">({customFields.length}/5 used)</span>
  </label>
</div>


      {isCreatingNew ? (
        <>
          <label className="apply-dot-heading">Field Name</label>
          <input
            className="apply-input-field pl-2 mt-1"
            placeholder="Enter your field name here"
            value={newFieldName}
            onChange={(e) => setNewFieldName(e.target.value)}
          />
          <label className="apply-dot-heading mt-2">Extraction Prompt</label>
          <textarea
            className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
            placeholder="Enter your Extraction Prompts here"
            value={newPrompt}
            onChange={(e) => setNewPrompt(e.target.value)}
          />
        </>
      ) : (
        <>
          <label className="apply-dot-heading">Choose Field</label>
      <CustomDropdown
  selected={selectedField}
  onSelect={setSelectedField}
  options={customFields.map((field) => field.field)}
/>


        </>
      )}

  <div className="absolute bottom-4 right-4 flex justify-end gap-3">
    <button
      className="cancel-apply-button-design"
      onClick={() => setIsCustomApplyFiledModal(false)}
    >
      Cancel
    </button>
    <button
      // onClick={handleApplyField}
      className={`apply-apply-button ${
        isLoading ? 'bg-[#D081D9]' : 'bg-[#D081D9] hover:bg-[#C26ED2]'
      }`}
    >
      {isLoading ? (
        <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : isCreatingNew ? (
        'Create & Apply'
      ) : (
        'Apply Field'
      )}
    </button>
  </div>
    </div>
  </div>
)}
{customFieldPopup.visible && (
  <div
    ref={popupRef}
    className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
    style={{
      top: `${customFieldPopup.y}px`,
      left: `${customFieldPopup.x - 30}px`,
      maxWidth: "300px",
      width: "max-content",
      whiteSpace: "normal",
    }}
    onMouseEnter={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
    }
    onMouseLeave={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
    }
  >
    <p className="text-gray-800 text-sm font-medium break-words">
      {customFieldPopup.value.length > 40
        ? `${customFieldPopup.value.slice(0, 40)}...`
        : customFieldPopup.value}
    </p>
    <button
      onClick={() =>
        handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)
      }
      className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
    >
      View More
    </button>
  </div>
)}
{/* File Preview Modal */}
{selectedFilePreview && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    onClick={() => setSelectedFilePreview(null)}
  >
    <div
      className="bg-white rounded-lg shadow-lg w-[55vw] h-[80vh] overflow-hidden relative"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Full Preview */}
      {selectedFilePreview.file_type === "pdf" ? (
     
          <PdfViewer
                            pdfUrl={selectedFilePreview.pdf_url}

                  
                />
      ) : (
        <PdfViewer
                            pdfUrl={selectedFilePreview.pdf_url}
      
        />
      )}
    </div>
  </div>
)}

<CreateTagModals
  isOpen={isTagModalOpen}
  onClose={() => setIsTagModalOpen(false)}
  documentId={tagModalDocIds}
  onTagUpdate={fetchContracts}     // refresh the table
  onClearSelection={() => {
    setSelectedContracts([]);
    setSelectedContractKeys([]);
  }}
/>

<GenerateProposalModal
  isOpen={isProposalOpen}
  onClose={() => setIsProposalOpen(false)}
  onGenerate={handleGenerateFromRfp}
/>


{isProposalPdfOpen && proposalPdfUrl && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    onClick={() => setIsProposalPdfOpen(false)} // Close the modal on overlay click
  >
    <div
      className="bg-white rounded-lg shadow-lg w-[55vw] h-[80vh] overflow-hidden relative"
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
    >
      {/* Display the PDF using your existing PdfViewer */}
      <PdfViewer pdfUrl={proposalPdfUrl} />
    </div>
  </div>
)}


      </div>
    </>
  );
};

export default ContractTable;